import {HTTP} from '@/CallAPI'
export default {
  getListGroupAlias (page = 1, per_page = '') {
    return HTTP.get('group-aliases', {params: {
      page,
      per_page
    }})
  },
  showGroupAlias (group_alias = {}) {
    return HTTP.get('group-aliases/' + group_alias.id)
  },
  updateGroupAlias (group_alias = {}) {
    return HTTP.put('group-aliases/' + group_alias.id, group_alias)
  },
  createGroupAlias (group_alias = {}) {
    return HTTP.post('group-aliases', group_alias)
  },
  destroyGroupAlias (group_alias = {}) {
    return HTTP.delete('group-aliases/' + group_alias.id)
  }
}



// WEBPACK FOOTER //
// ./src/service/group-alias.js